import { types } from 'mobx-state-tree'
import { AssessmentStat } from './AssessmentStat'

export const AssessmentStats = types.model('AssessmentStats').props({
  id: types.number,
  preTestStats: types.maybeNull(AssessmentStat),
  postTestStats: types.maybeNull(AssessmentStat),
})
